import type { PropType } from 'vue'
import { defineComponent, computed } from 'vue'
import SvgIcon from '../svgIcon/index.vue'

import './style.less'

export default defineComponent({
  props: {
    mobile: Boolean as PropType<boolean>,
    type: Number as PropType<NewsType>,
    absolute: Boolean as PropType<boolean>,
    absoluteStyle: Object as PropType<object>,
    photoNum: Number as PropType<number>,
    videoInfo: {
      type: Object as PropType<VideoInfoItem>,
      default: () => {
        return {} as VideoInfoItem
      }
    },
    liveInfo: {
      type: Object as PropType<LiveInfoItem>,
      default: () => {
        return {}
      }
    }
  },
  setup(props, { attrs }) {
    const hasExtra = computed(() => {
      return [1, 2, 5, 9].includes(props.type || 0)
    })

    const liveStatus = computed(() => {
      if (props.liveInfo?.liveState === 'running') return 'Live'
      if (props.liveInfo?.liveState === 'wait') return 'Preview'
      if (props.liveInfo?.liveState === 'end' && !!props.liveInfo.replayUri) return 'Review'
      if (props.liveInfo?.liveState === 'end' && !props.liveInfo.replayUri) return 'End'
    })

    return () => {
      return (
        <>
          {hasExtra.value && (
            <div
              class={[
                'news-extra',
                attrs.class,
                props.absolute ? 'absolute' : '',
                props.mobile ? 'mobile' : ''
              ]}
            >
              {props.type === 1 && !!Object.keys(props.videoInfo)?.length && (
                <div class={'news-video-extra'}>
                  <SvgIcon
                    name={'extra-video'}
                    class={props.mobile ? 'w-18px h-18px' : 'w-18px h-18px'}
                  />
                  <div class={['video-sub-title']}>{props.videoInfo.durationStr}</div>
                </div>
              )}
              {props.type === 2 && !!Object.keys(props.liveInfo)?.length && (
                <div class={'live-extra'}>
                  {props.liveInfo?.liveState === 'running' ? (
                    <SvgIcon
                      name={props.liveInfo?.vrType === 1 ? 'media-vr' : 'extra-live'}
                      class={props.mobile ? 'w-18px h-18px' : 'w-18px h-18px'}
                    />
                  ) : null}
                  <div class={['live-sub-title', props.liveInfo?.liveState]}>
                    {liveStatus.value}
                  </div>
                </div>
              )}
              {props.type === 5 && (
                <div class={'topic-extra'}>
                  <SvgIcon
                    name={'extra-special'}
                    class={props.mobile ? 'w-16px h-18px' : 'w-16px h-18px'}
                  />
                  <div class={['topic-sub-title']}>Special Report</div>
                </div>
              )}
              {props.type === 9 && !!props.photoNum && (
                <div class={'photo-extra'}>{props.photoNum}&nbsp;Photos</div>
              )}
            </div>
          )}
        </>
      )
    }
  }
})
